import { RESET_STATE } from 'store/global/actions';
import { LOAN_ACTIONS_ACTION_TYPE } from 'store/system/actions';

const initialState = { criteriaSchema: {}, fields: {}, integrationFields: {} };

const loanActionsEditorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTION_CRITERIA_SCHEMA:
      return {
        ...state,
        criteriaSchema: payload || state.criteriaSchema,
      };
    case LOAN_ACTIONS_ACTION_TYPE.GET_LOAN_ACTION_POSSIBLE_FIELDS:
      return {
        ...state,
        fields: payload || state.fields,
      };
    case LOAN_ACTIONS_ACTION_TYPE.GET_INTEGRATION_STUDIO_FIELDS:
      return {
        ...state,
        integrationFields: payload || state.integrationFields,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default loanActionsEditorReducer;
